// @flow

import styled from 'styled-components';
import { lighten } from 'polished';
import { colors, fonts } from 'shared/styleguide';

export const MENU_WIDTH = 270;

export const Wrapper = styled.div`
  z-index: 2;
  position: fixed;
  left: 0;
  top: 0;
  max-width: ${MENU_WIDTH}px;
  min-width: ${MENU_WIDTH}px;
  width: 100%;
  height: 100vh;
  background: #FAFAFA;
  border-right: none;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  transition: transform 300ms ease;
  transform: translateX(${p => (p.show ? 0 : '-100%')});

  /* Mobile drawer shadow */
  box-shadow: ${p => (p.show ? '0 4px 10px 0 rgba(66, 68, 76, 0.15)' : 'none')};

  @media (min-width: 1000px) {
    transition: none;
    box-shadow: none;

    max-width: ${MENU_WIDTH}px;

    /* Ensure the menu is always in view in Desktop mode */
    margin-left: ${MENU_WIDTH}px;
    transform: translateX(-${MENU_WIDTH}px);
  }
`;

export const TopArea = styled.div`
  flex-shrink: 0;
  width: 100%;
  padding: 12px 16px 0;
  text-align: left;
  display: flex;
  transition: opacity 0.2s linear;

  /* Logo hover */
  &:hover {
    opacity: 0.8;
  }

  @media (min-width: 1000px) {
    padding: 16px 16px 0 20px;
  }
`;

/* The middle nav list is the only part that scrolls - the logo above and
   Settings below always stay pinned in place, regardless of how many
   groups are expanded/collapsed. */
export const ScrollArea = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  padding: 0 16px;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;

  /* Slim scrollbar */
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  &:hover::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.25);
  }

  @media (min-width: 1000px) {
    padding: 0 16px 0 20px;
  }
`;

export const BottomBar = styled.div`
  flex-shrink: 0;
  width: 100%;
  padding: 12px 16px 20px;

  @media (min-width: 1000px) {
    padding: 12px 16px 24px 20px;
  }
`;

export const Header = styled.div`
  padding-bottom: 24px;

  svg {
    width: 170px;
    height: auto;
    border-radius: 0;
    object-fit: contain;
    display: block;
  }

  @media(min-width: 1000px) {
    display: block;
  }
`;

export const MenuList = styled.div`
  width: 100%;
  margin: 0;
  padding: 12px 0 16px;
`;

export const SectionDivider = styled.hr`
  border: none;
  border-top: 1px solid ${colors.lightBlueGrey};
  margin-top: 24px;
  margin-bottom: 24px;
  width: 100%;
`;

export const MenuGroupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  cursor: pointer;
  user-select: none;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  color: #1A1A1A;
  margin-bottom: 16px;
  margin-top: 24px;
  text-transform: none;
  letter-spacing: 0;
  transition: opacity 200ms ease;

  &:hover {
    opacity: 0.7;
  }

  span {
    flex: 1;
  }
`;

export const MenuGroupContent = styled.div`
  /* No special styling needed - items will render normally */
`;

export const MenuItemWrapper = styled.div`
  margin-bottom: 8px;
  border-left: none;

  /* An <a> tag is wrapped around the entire menu item to allow new tab clicks */
  a {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0;
    text-decoration: none;
    transition: all 0.2s ease;
    cursor: pointer;

    svg {
      width: 20px;
      height: 20px;
      color: ${p => (p.active ? '#FFFFFF' : '#666666')};
      transition: color 0.2s ease;
    }

    &:visited {
      text-decoration: none;
    }

    /* The <span> within the a tag is used for hover and active-mode effects */
    span {
      width: 100%;
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: center;
      border-radius: 8px;
      padding: 10px 12px;
      background-color: ${p => (p.active ? '#E31E24' : 'transparent')};
      transition: background-color 0.2s ease;
    }
  }

  &:hover {
    cursor: pointer;

    a span {
      background-color: ${p => (p.active ? '#E31E24' : '#EEEEEE')};
    }
  }
`;

export const MenuItemTitle = styled.div`
  color: ${p => (p.active ? '#FFFFFF' : '#333333')};
  flex: 1;
  padding-left: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.2s ease;
`;
